<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <BRow
      class="mb-2"
    >
      <BCol
        cols="12"
        class="px-1"
      >
        <div
          class="card card-body p-3 rounded-lg mt-2"
        >
          <div class="d-flex flex-column flex-md-row align-items-md-center gap-5">
            <div class="flex-grow-1">
              <div class="h3">
                Good {{ greetings }}, <b class="text-primary">{{ currentUser?.name || 'Officer' }}</b>
              </div>
              <div>
                Your team performance summary for month of {{ monthLongFormatter(filters.month) }}
              </div>
            </div>
            <div>
              <BFormGroup
                label="Month"
                label-for="filterMonth"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <flat-pickr
                  id="filterMonth"
                  v-model="filters.month"
                  class="form-control"
                  placeholder="--------- ----"
                  :config="flatPickerConfig"
                />
              </BFormGroup>
            </div>
          </div>
        </div>
      </BCol>
      <BCol
        cols="12"
        class="px-1"
      >
        <AreaManager
          :busy="state.busy"
          :area-managers="areaManagerTasks"
          :trading-terms="trading_terms"
          :business-agreements="business_agreements"
          class="mb-4 mt-2"
        />
      </BCol>
    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import createDate from 'moment'
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'

import AreaManager from '@/views/rsm/dashboard/AreaManagers.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MActivities from '@/mixins/maintenances/activities'
import MCustomers from '@/mixins/accounts/customers'

import { SRSMDashboard } from '@/services/rsm'

// import Tasks from '@/views/rsm/dashboard/Tasks.vue'

export default {

  name: 'RSMDashboardBase',

  components: {
    AreaManager
    // Tasks
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl,
    MActivities,
    MCustomers
  ],

  middleware: ['auth', 'rsm'],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      },
      state: {
        busy: false,
        editing: false
      },
      tasksCurrentTabIndex: 0,
      filters: {
        month: createDate().format('YYYY-MM')
      },
      business_agreements: [],
      trading_terms: [],
      taskSummaries: {
        totalRows: 0,
        rows: []
      },
      areaManagerTasks: {
        totalRows: 0,
        rows: []
      }
    }
  },

  computed: Object.assign({
    greetings () {
      const currentHourOfTheDay = createDate().hour()

      if (currentHourOfTheDay >= 3 && currentHourOfTheDay < 12) {
        return 'Morning'
      } else if (currentHourOfTheDay === 12) {
        return 'Noon'
      } else if (currentHourOfTheDay > 12 && currentHourOfTheDay < 18) {
        return 'Afternoon'
      } else if (currentHourOfTheDay >= 18 && currentHourOfTheDay < 20) {
        return 'Evening'
      } else {
        return 'Night'
      }
    }
  }, mapGetters({
    currentUser: 'auth/user'
  })),

  watch: {
    'filters.month' (month) {
      if (!month) {
        this.filters.month = createDate().format('YYYY-MM')
      } else {
        this.gridProvider()
      }
    }
  },

  mounted () {
    if (this.currentUser) {
      this.gridProvider()
    }
  },

  methods: {

    async gridProvider () {
      this.state.busy = true

      const payload = {
        schedule: this.filters.month
      }

      return SRSMDashboard.getActivitySummaries(payload).then(
        ({ data }) => {
          const taskSummaries = data?.activity_summaries || []
          const taskProgress = data?.supervisor_summaries || data?.area_sales_summaries || []

          this.trading_terms = data?.trading_terms || []
          this.business_agreements = data?.business_agreements || []

          this.taskSummaries = {
            totalRows: Array.from(taskSummaries || []).length,
            rows: taskSummaries || []
          }

          this.areaManagerTasks = {
            totalRows: Array.from(taskProgress || []).length,
            rows: taskProgress || []
          }
        }
      ).catch(() => {
        this.trading_terms = []
        this.business_agreements = []

        this.taskSummaries = {
          totalRows: 0,
          rows: []
        }
        this.areaManagerTasks = {
          totalRows: 0,
          rows: []
        }
      }).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
